<template>
  <div class="dummy-island">
    <h3>{{ title }}</h3>
    <p>This is a simulated island component.</p>
    <button @click="triggerCrash">💥 Crash Me</button>
  </div>
</template>

<script>
export default {
  name: 'DummyIsland',
  props: {
    title: { type: String, default: 'Island' }
  },
  setup() {
    const triggerCrash = () => {
      throw new Error("Simulated Island Crash!");
    };
    return { triggerCrash };
  }
}
</script>

<style scoped>
.dummy-island {
  border: 2px dashed #42b883;
  padding: 20px;
  margin: 10px 0;
  border-radius: 8px;
}
</style>
